module.exports = __webpack_public_path__ + "static/media/27_tn.76bbd7bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/thumbnails/27_tn.jpg
// module id = 457
// module chunks = 0